<template>
  <div
    ref="product_more_filter"
    id="product_more_filter"
    class="modal modal-right fade modal-more-filters"
  >
    <div
      class="modal-dialog"
      style="width: 360px"
    >
      <div class="modal-content">
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("More Filters") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <!-- category -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('category')"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-category"
                name="category"
              >
                <div>{{ $t("Category") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', { 'rotate-180': options.category }]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="collapse ui-filter-list card-body px-4"
              id="collapse-category"
            >
              <div class="filter-option">
                <div class="form-group form-group-feedback form-group-feedback-right">
                  <div id="tags-search"> 
                    <Select2
                      v-model="dataFilter.category_ids"
                      :options="optionCategory"
                      :settings="settingOptionCategory"
                      :placeholder="$t('Search by Category name...')"
                      name="category"
                    />
                  </div>
                  <div class="form-control-feedback">
                    <i class="fa-solid fa-magnifying-glass" />
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('category')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Product Type -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('product_type')"
                name="product_type"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-product_type"
              >
                <div>{{ $t("Product Type") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="[
                        'list-icons-item',
                        { 'rotate-180': options.product_type },
                      ]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4"
              id="collapse-product_type"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{ 'mb-0': !productType.length }"
                >
                  <div
                    class="form-check"
                    v-for="product in productType"
                    :key="'payment-method-' + product.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span
                          :class="[
                            dataFilter.product_type == product.id ? 'checked' : '',
                          ]"
                        >
                          <input
                            type="radio"
                            name="adv_payment_filter"
                            :id="product.id"
                            :value="product.id"
                            v-model="dataFilter.product_type"
                            @click="disabledStatusIdUncheck('payment_method')"
                          >
                        </span>
                      </div>
                      {{ $t(product.name) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('product_type')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>

          <!-- order status -->
          <div
            class="card card-collapsed border-0 shadow-none mb-0"
          >
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('status')"
                name="status"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-status"
              >
                <div>{{ $t("Order Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', { 'rotate-180': options.order_status }]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4"
              id="collapse-status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{ 'mb-0': !statusList.length }"
                >
                  <div
                    class="form-check"
                    v-for="Status in statusList"
                    :key="'order-status-' + Status.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span
                          :class="[
                            dataFilter.order_status === Status.id ? 'checked' : '',
                          ]"
                        >
                          <input
                            type="radio"
                            name="adv_status_filter"
                            :id="Status.name"
                            :value="Status.id"
                            v-model="dataFilter.order_status"
                            @click="disabledStatusIdUncheck('order_status')"
                          >
                        </span>
                      </div>
                      <span>{{ $t(Status.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('status')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3"
          >
            <button
              @click="clearAll"
              type="button"
              class="btn btn-light"
            >
              {{ $t("clear all filters") }}
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="submit" 
            >
              {{ $t("Done") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/services/endpoint/tenant.service';
import Select2 from "v-select2-component";
import { convertTimezone } from "@/common/tenancy/convertTimezone";

export default {
  name: "ProductCategoryMoreFilter",
  components: {
    Select2,
  },
  props: {
    statusList: {
      type: [Object, Array],
      default: undefined
    },
    paymentStatus: {
      type: [Object, Array, String, Number],
      default: undefined
    },
    productType: {
      type: [Object, Array],
      default: undefined
    },
  },
  data() {
    return {
      dataFilter: initialFilter(),
      options: {
        product_type: false,
        order_status: false,
        category: false,
      },
      datainfo: {
        date: {
          singleDatePicker: 'range',
          opens: 'right',
          ranges: true,
          appendtobody: true,
          autoApply: true,
          localedata: {
            format: 'dd/mm/yyyy',
          }
        },
      },
      optionCategory: [],
      settingOptionCategory: {
        language: {
          // noResults: this.noResults,
          minimumResultsForSearch: Infinity,
          maximumSelected: function (e) {
              var text = vm.$t('_Tags.You can only select')+ ' ' + e.maximum + ' ' + vm.$t('_Tags.items');
              return text;
          },
          searching: () => {
            return this.$t('Searching...');
          },
          loadingMore:function (e) {
              return '<i class="fa fa-spinner fa-spin"></i>';
          },
        },
        templateResult: this.templateCustomCategory,
        templateSelection: this.templateSelectCategory,
        ajax: {
          cache: true,
          delay: 250,
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
          },
          url: Api.AUTH.URL + Api.URL.PRODUCT_CATEGORIES,
          data: function(params) {
              const query = {
                search: params.term,
                page: params.page || 1
              }
              return Api.Signature.create($.param(query)).substring(1);
          },
          processResults: function (data, params) {
              let option = data.data;
              let pageCurrent = data.meta.page
              option = option.map( function(item) {
                return {
                  id: item.id,
                  text: item.name,
                  image: item.images ? item.images[0] : '',
                  ctid: item.id,
                }
              })
              return {
                results: option,
                pagination: {
                  more: (pageCurrent * 10) < data.meta.total
                }
              };
          }
        }
      },
    };
  },
  mounted() {
    // $("#product_more_filter").modal("show"); 
    this.dataFilter.product_type = this.$parent.paramsQuery.product_type;
    this.dataFilter.order_status = this.$parent.paramsQuery.order_status;
    // this.dataFilter.category_ids = this.$parent.paramsQuery.category_ids;
    let vm = this;
    setTimeout(() => {
      vm.dataFilter.category_ids = vm.$parent.paramsQuery.category_ids.length > 0 ? vm.$parent.paramsQuery.category_ids[0] : [];
    }, 500);
  },
  watch: {
  },
  methods: {
    toggleOption(key) {
      if (key == "product_type") {
        this.options.product_type
          ? (this.options.product_type = false)
          : (this.options.product_type = true);
      } else if (key == "status") {
        this.options.order_status
          ? (this.options.order_status = false)
          : (this.options.order_status = true);
      } else if (key == "category") {
        this.options.category
          ? (this.options.category = false)
          : (this.options.category = true);
      }
    },
    submit() {
      if (!this.dataFilter.product_type) {
        this.dataFilter.product_type = [];
      }
      if (!this.dataFilter.order_status) {
        this.dataFilter.order_status = [];
      }
      if (!this.dataFilter.category_ids) {
        this.dataFilter.category_ids = [];
      } 
      this.$emit("onSubmit", this.dataFilter);
      
    },
    clearAll() {
      this.dataFilter = initialFilter();
    },
    clearFilter(key) {
      if (key == "product_type") {
        this.dataFilter.product_type = null;
      } else if (key == "status") {
        this.dataFilter.order_status = null;
      } else if (key == "category") {
        this.dataFilter.category_ids = [];
      } else if (key == "all") {
        this.dataFilter = initialFilter();
      }
    },
    templateCustomCategory: function (option) {
      if (!option.id) {
        return $(`<div class="loading-small p-0" style="z-index:9999; height:0;"></div>`);
      }else{
        if (!option.name) {
          option.name = option.text;
        }
        let optionName = option.name;
        let image = option.image ? option.image : require('@/assets/images/no-category-image.png');
        let txt = $(`<div class='list-item d-flex templatecustom'><div class='item-content'><div class='item-name'>
        <img src="${image}" class="mr-2 rounded" width="20">${optionName}</div></div></div>`);
        return txt;
      }
    }, 
    templateSelectCategory: function (option) {
        if (!option.name) {
          option.name = option.text;
        }
        this.$parent.dataCategory = option;
        let optionName = option.name;
        let image = option.image ? option.image : require('@/assets/images/no-category-image.png');
        let txt = $(`<div class='list-item d-flex templatecustom'><div class='item-content'><div class='item-name'>
        <img src="${image}" class="mr-2 rounded" width="20">${optionName}</div></div></div>`);
        return txt;
    }, 
    disabledStatusIdUncheck(choose) {
      let self = this;
      setTimeout(() => {
        if(choose == 'order_status') {
          // self.datainfo.payment_status.map(function(item){
          //   if(item.disabledStatusId.includes(self.dataFilter.order_status)) {
          //     const index = self.dataFilter.payment_status.indexOf(item.id);
          //     if (index > -1) {
          //       self.dataFilter.payment_status.splice(index, 1);
          //     }
          //   }
          // });
        } else if(choose == 'payment_method') {
          // if(self.$parent.activeTab == 'returned') {
          //   // Method = COD, Payment Status จะ Filter ได้เฉพาะ Pending
          //   // Method = Bank Tranfer, Payment Status จะ Filter ได้เฉพาะ Confirmed
          //   if(self.dataFilter.payment_status.length > 0){
          //     if(
          //       self.dataFilter.payment_status == 'pending' && !self.dataFilter.payment_method_ids.includes(2) ||
          //       self.dataFilter.payment_status == 'confirmed' && !self.dataFilter.payment_method_ids.includes(1)
          //     ) {
          //       self.dataFilter.payment_status = [];
          //     }
          //   }
          // }
        }
      }, 100);
    },
    convertTimezone(date) {
      return date != null && new Date(date) instanceof Date && !isNaN(new Date(date))
        ? convertTimezone.utcToLocal(date)
        : "-";
    },
  },
};

function initialFilter() {
  return {
    product_type: null,
    order_status: null,
    category_ids: [],
  };
}
</script>
<style scoped>
/* .uniform-checker span {
    color: #888 !important;
    border: 0.125rem solid #888 !important;
  }
  .uniform-choice span {
    color: #888 !important;
    border: 0.125rem solid #888 !important;
  } */
</style>

<style>
.image_select2 {
  width: 17.4px !important;
  height: 17.4px !important;
  object-fit: cover !important;
}
#staff-search .select2-container--default .select2-selection--multiple .select2-search--inline .select2-search__field {
  width: 100% !important;
}
.select2-results__option--highlighted #salesStaff .text-danger {
  color: black !important;
}
.select2-container--default .staff-search .select2-results>.select2-results__options {
  overflow-x: hidden;
}
.time-type .select2-selection__arrow:after {
  right: 0.5rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/ProductCategoryMoreFilter.vue